import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Tour from "reactour";

const OnBoarding = (props) => {
  const [t,i18n] = useTranslation("onBoarding")
  const [showTour, setShowTour] = useState(false);
  const startTour = () => setShowTour(true);
  const finishTour = () => setShowTour(false);

  const [show, setShow] = useState(true);

  const neverMoreShow = () => {
    window.localStorage.setItem("onBoardProjects", true);
  };

  const handleClose = () => {
    setShow(false);
    startTour();
  };
  const handleCloseEnd = () => {
    // when user saw all the cards
    setShow(false);
    finishTour();
    neverMoreShow();
  };
  const handleCloseSkip = () => {
    setShow(false);
  };
  const handleCloseSkipForever = () => {
    setShow(false);
    neverMoreShow();
  };

  let showOnboarding = window.localStorage.getItem("onBoardProjects");

  const steps = [
    {
      selector: '[data-tour="step-1"]',
      content: (
        <p>{t("stepbystep_guidedtour_projects_step1_1")} <b>{t("stepbystep_guidedtour_projects_step1_2")}</b> {t("stepbystep_guidedtour_projects_step1_3")} </p>
      ),
    },
    {
      selector: '[data-tour="step-2"]',
      content: (
        <p>{t("stepbystep_guidedtour_projects_step2_line1_1")} 
        <b>{t("stepbystep_guidedtour_projects_step2_line1_2")}</b>{t("stepbystep_guidedtour_projects_step2_line1_3")} <b>{t("stepbystep_guidedtour_projects_step2_line1_4")}</b>{t("stepbystep_guidedtour_projects_step2_line1_5")}
        <br />
        <br />
        <b>{t("stepbystep_guidedtour_projects_step2_line2_1")}</b> {t("stepbystep_guidedtour_projects_step2_line2_2")}
        </p>
      ),
    },
    {
      content: (
        <p>
          {t("stepbystep_guidedtour_projects_step3_1")}
          <a
            href="https://projects.co.pwc.com/testagilidad/test/index.html#/"
            target="_blank"
            rel="noreferrer noopener"
          >
            {t("stepbystep_guidedtour_projects_step3_2")}
          </a>
        </p>
      ),
    },
    {
      selector: '[data-tour="step-1"]',
      content: (

        <p>{t("stepbystep_guidedtour_projects_step4_1")}<b>{t("stepbystep_guidedtour_projects_step4_2")}</b>{t("stepbystep_guidedtour_projects_step4_3")}</p>
      ),
    },
    {
      selector: '[data-tour="step-4"]',
      content: (
        <p>
        {t("stepbystep_guidedtour_projects_step5")}
        </p>
      ),
    },
    {
      content: (
        <div className="text-center pt-3">
          <p>{t("stepbystep_guidedtour_projects_step6")}</p>
          <Button variant="success" onClick={handleCloseEnd} size="md">
            {t("stepbystep_welcome_button_thanks")}
          </Button>
        </div>
      ),
    },
  ];

  if (showOnboarding || !props.show) {
    return (
      <>
        <Button
          variant="info"
          className="position-fixed shadow animate__animated animate__fadeInUp animate__delay-2s"
          style={{ bottom: "1rem", left: "1rem" }}
          onClick={startTour}
        >
          <i className="fa fa-question-circle"></i>
        </Button>
        <Tour
          onRequestClose={finishTour}
          steps={steps}
          isOpen={showTour}
          className="helper"
          rounded={5}
          accentColor="#e0301e"
        />
      </>
    );
  }

  return (
    <div>
      <Modal
        show={show}
        contentClassName="border-0"
        centered
      >
        <Modal.Body>
          <h5>{t("stepbystep_guidedtour")}</h5>
          <p>
            {t("stepbystep_guidedtour_tittle")}
          </p>
          <div className="d-flex justify-content-between">
            <div>
              <Button
                variant="outline-primary"
                onClick={handleCloseSkip}
                size="md"
                className="mr-2"
              >
                <i className="fa fa-times mr-2"></i>{t("stepbystep_guidedtour_button_skip")}
              </Button>{" "}
              <a href="#" onClick={handleCloseSkipForever} className="small">
                {t("stepbystep_guidedtour_button_donotseemore")}.
              </a>
            </div>
            <Button variant="success" onClick={handleClose} size="md">
              ¡{t("stepbystep_guidedtour_button_showme")}!<i className="fa fa-arrow-right ml-2"></i>
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Tour
        onRequestClose={finishTour}
        steps={steps}
        isOpen={showTour}
        className="helper"
        rounded={5}
        accentColor="#e0301e"
      />
    </div>
  );
};

export default OnBoarding;
